// @systeme: interface
// Réduire une photo avant de l'envoyer : une photo de téléphone pèse 3 à 12 Mo et fait
// 4000 px de côté ; il en faut moins pour qu'un modèle lise un mot d'école. On la ramène
// à 1600 px de côté au plus, en JPEG. Si elle est déjà petite (en pixels ET en octets),
// ou si le navigateur ne sait pas faire, on envoie l'original : rien ne se perd.
const COTE_MAX = 1600;
const QUALITE = 0.85;
const SEUIL_OCTETS = 400 * 1024;

export async function reduireImage(fichier: Blob & { name?: string }): Promise<Blob> {
  if (!fichier.type.startsWith('image/')) return fichier;
  if (typeof createImageBitmap !== 'function' || typeof document === 'undefined') return fichier;
  try {
    const image = await createImageBitmap(fichier);
    const cote = Math.max(image.width, image.height);
    if (cote <= COTE_MAX && fichier.size <= SEUIL_OCTETS) {
      image.close();
      return fichier;
    }
    const rapport = Math.min(1, COTE_MAX / cote);
    const largeur = Math.max(1, Math.round(image.width * rapport));
    const hauteur = Math.max(1, Math.round(image.height * rapport));
    const toile = document.createElement('canvas');
    toile.width = largeur;
    toile.height = hauteur;
    const contexte = toile.getContext('2d');
    if (!contexte) return fichier;
    contexte.drawImage(image, 0, 0, largeur, hauteur);
    image.close();
    const reduite = await new Promise<Blob | null>((resoudre) =>
      toile.toBlob(resoudre, 'image/jpeg', QUALITE),
    );
    if (!reduite || reduite.size >= fichier.size) return fichier;
    return reduite;
  } catch {
    return fichier;
  }
}

/** Le nom du fichier envoyé : « mot-ecole.heic » devient « mot-ecole.jpg » une fois réduit. */
export function nomReduit(nom: string, reduite: boolean): string {
  return reduite ? nom.replace(/\.[A-Za-z0-9]+$/, '') + '.jpg' : nom;
}
